import { FC } from "react";
import { useDispatch } from "react-redux";

import { UserLoyaltyProgramForm } from "Bands/components";
import { createUserLoyaltyProgram, dispatchGetUserLoyaltyPrograms } from "Bands/state";
import { IUserLoyaltyProgramPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Passport } from "shared/assets/icons";

const { userLoyaltyProgram: loyaltyCopy } = copy;

interface Props {
  handleClose: () => void;
}

export const CreateUserLoyaltyProgram: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const buttons: IFormButtons = {
    primary: {
      children: loyaltyCopy.buttons.create,
    },
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserLoyaltyProgramPatchData) => {
    dispatch(createUserLoyaltyProgram(data));
  };

  const handleSuccess = () => {
    dispatchGetUserLoyaltyPrograms(dispatch);
  };

  return (
    <UserEntityModal
      title={loyaltyCopy.create.title}
      icon={Passport}
      action={USER_ACTIONS.createUserLoyaltyProgram}
      buttons={buttons}
      successMessage={loyaltyCopy.messages.created}
      Component={UserLoyaltyProgramForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
    />
  );
};
